import React, { Component } from 'react';
import _ from 'lodash';
import { Row, Tabs, Col, Card, Avatar, notification, Spin, message, Tooltip, Rate, Select, Table} from 'antd';
import { Breadcrumb } from '../common/atoms';
import {LeftChevronIcon} from '../../assets/images';
import Highcharts from 'highcharts';
import Highstock from 'highcharts/highstock';
import ReactHighcharts from 'react-highcharts';
import { withDsChartTheme } from './../../utils/chartTheme';
const Charts = withDsChartTheme(ReactHighcharts.withHighcharts(Highstock));
const { Meta } = Card;
const TabPane = Tabs.TabPane;
const { Option } = Select;

class HealthCheckTrends extends Component {
  constructor(props) {
      super(props);
      this.state = {
        loading: false,
        data: {},
        dropdownValue: "last_30_days",
        employeeCountOverall: {filters:[], config: {}},
        baseConfig : {
          filters: [],
          config: {
            chart: {},
            title: {text: '', align: 'left'},
            subtitle: { text: '', align: 'left' },
            xAxis: {},
            yAxis: {},
            credits: {
              enabled: false
            },
            series: []
          }
        }
      };
  }

  componentDidMount () {
    let that = this;
    this.setState({loading: true})
    window.axios.get(window.API_URL + 'corporate/health_check_trends')
      .then(function (response) {
        console.log(response.data)
        that.setState({ 
                       loading: false,
                       data: response.data})
      })
      .catch(function (error) {
        that.setState({loading: false})
        notification['error']({
        message: 'Something Went Wrong',
        description: "Please try again later"
        })
        console.log(error);
      })
  }

  handleChange(e){
    let that = this
    that.setState({dropdownValue: e})
  }

  renderHealthChecks(){
    sessionStorage.setItem('defaultSelectedTab', '120')
    this.props.history.push({pathname: '/utilization/ahc'})
  }

  renderEachDayChartTrends(e){
    let that = this
    let a = 'weekday_' + e
    let text = ""
    if (e === "last_30_days"){
      text = "last 30 days"
    }else if(e === "last_12_months"){
      text = "last 12 months"
    }else if(e === "last_year"){
      text = "last year"
    }else if(e === "overall"){
      text = "lifetime"
    }
    return(
      <div>
        <Row>
          <Col span={12}>
            <h5 style={{color: '#6B7280'}}>Based on when the appointments are scheduled</h5>
          </Col>
          <Col span={12}>
            <Row type="flex" justify="end" style={{marginLeft: 0,marginBottom: 20}}>
              <h6 style={{color: '#6B7280',fontSize: 14}}>The data belongs to <span className="semibold" style={{color: '#475569'}}>{text} </span></h6>
            </Row>
          </Col>
        </Row>  
        {this.renderEachDayChart(that.state.data[a])}
      </div>
    )
  }

  renderEachHourChartTrends(e){
    let that = this
    let a = 'hourly_' + e
    let text = ""
    if (e === "last_30_days"){
      text = "last 30 days"
    }else if(e === "last_12_months"){
      text = "last 12 months"
    }else if(e === "last_year"){
      text = "last year"
    }else if(e === "overall"){
      text = "lifetime"
    }
    return(
      <div>
        <Row>
          <Col span={12}>
            <h5 style={{color: '#6B7280'}}>Based on when the appointments are created</h5>
          </Col>
          <Col span={12}>
            <Row type="flex" justify="end" style={{marginLeft: 0,marginBottom: 20}}>
              <h6 style={{color: '#6B7280',fontSize: 14}}>The data is of <span className="semibold" style={{color: '#475569'}}>{text} </span></h6>
            </Row>
          </Col>
        </Row>    
        {this.renderEachDayChart(that.state.data[a])}
      </div>
    )
  }

  renderEachDayChart(record){
    let that = this
    let keys = Object.keys(record)
    let baseConfig = _.cloneDeep(that.state.baseConfig)
    let series = Object.values(record)
    baseConfig.config.chart.type = 'column'
    baseConfig.config.yAxis.title = {text: "Health Checks Count"}
    baseConfig.config.yAxis.allowDecimals = false 
    baseConfig.config.xAxis = {categories: keys
                              } 
                             
    baseConfig.config.plotOptions = {column: {dataLabels: { enabled: false},enableMouseTracking: true,events: {
            legendItemClick: function () {
                return false; 
            }
        }},
        series: {pointWidth: 10,dataLabels: {enabled: true,format: '{point.y:.0f}'}}}
     
    baseConfig.config.series = [{name: 'Health Checks Count',data: series.map(Number),color: '#2563EB',color1: '#ffffff'}]
    return(
      <div style={{marginTop: 30}}>
        <Charts 
          config={baseConfig.config}/> 
      </div>
    )
  }

  renderChartTrends(){
    let that = this
    let a = that.state.dropdownValue
    if(a === "last_30_days"){
      return(
        <div>
          {this.renderDaysChart(that.state.data[a],a)}
        </div>
      )
    }else{
      return(
        <div>
          {this.renderChart(that.state.data[a],a)}
        </div>
      )
    }    
  }

  renderChart(record,dv){
    let that = this
    let keys = Object.keys(record)
    let baseConfig = _.cloneDeep(that.state.baseConfig)
    let series = Object.values(record)
    let value = dv + '_apts'
    baseConfig.config.chart.type = 'line'
    baseConfig.config.yAxis.title = {text: "Health Checks Count"}
    baseConfig.config.yAxis.allowDecimals = false 
    baseConfig.config.xAxis = {categories: keys
                              }                             
    baseConfig.config.plotOptions = {line: {dataLabels: { enabled: false},enableMouseTracking: true,events: {
            legendItemClick: function () {
                return false; 
            }
        }}}
     
    baseConfig.config.series = [{name: 'Health Checks Count',data: series.map(Number),color: '#2563EB',color1: '#ffffff'}]
    return(
      <div style={{marginTop: 30}}>
        <Row type="flex" justify="end" style={{marginBottom: 20}} className="mt-minus-15">
          <h4 className="semibold" style={{color: '#6B7280'}}><span className="semibold" style={{color: '#2563EB'}}>{parseInt(that.state.data[value]).toFixed(0)}</span> Health Checks Completed</h4>
        </Row>
        <Charts 
          config={baseConfig.config}/>
        <Card className="health-check-utilization-card" style={{marginBottom: 20,marginTop: 10}}>
          <Row>
            <Col span={24}>
              <Tabs defaultActiveKey="1" >
                <TabPane tab="Each Day" key="1">
                  {this.renderEachDayChartTrends(dv)}
                </TabPane>
                <TabPane tab="Each Hour" key="2">
                  {this.renderEachHourChartTrends(dv)}
                </TabPane>
              </Tabs>    
            </Col>
          </Row> 
        </Card>  
      </div>
    )
  }

  renderDaysChart(record,dv){
    let that = this
    let baseConfig = _.cloneDeep(that.state.baseConfig)
    let value = dv + '_apts'
    baseConfig.config.chart.type = 'line'
    baseConfig.config.xAxis = {type: 'datetime',
                              dateTimeLabelFormats: {
                                  month: '%d. %b',
                                  year: '%b'
                                }
                              }                            
    baseConfig.config.yAxis.title = {text: "Health Checks Count"}   
    baseConfig.config.yAxis.allowDecimals = false                     
    baseConfig.config.plotOptions = {line: {dataLabels: { enabled: false},enableMouseTracking: true,events: {
            legendItemClick: function () {
                return false; 
            }
        }}}
    baseConfig.config.series = [{name: 'Health Checks Count',data: record,color: '#2563EB'}]
    return(
      <div style={{marginTop: 30}}>
        <Row type="flex" justify="end" style={{marginBottom: 20}} className="mt-minus-15">
          <h4 className="semibold" style={{color: '#6B7280'}}><span className="semibold" style={{color: '#2563EB'}}>{parseInt(that.state.data[value]).toFixed(0)}</span> Health Checks Completed</h4>
        </Row>
        <Charts 
          config={baseConfig.config}/>
        <Card className="health-check-utilization-card" style={{marginBottom: 20,marginTop: 10}}>
          <Row>
            <Col span={24}>
              <Tabs defaultActiveKey="1" >
                <TabPane tab="Each Day" key="1">
                  {this.renderEachDayChartTrends(dv)}
                </TabPane>
                <TabPane tab="Each Hour" key="2">
                  {this.renderEachHourChartTrends(dv)}
                </TabPane>
              </Tabs>    
            </Col>
          </Row> 
        </Card>   
      </div>
    )
  }

  getColor(value){
    let color = '#E5E7EB'
    if (value === 'Rare') {
      color = '#BFDBFE'
    }else if(value === 'Occasional'){
      color = '#2563EB'
    }else if(value === 'Frequent'){
      color = '#1E40AF'
    }
    return color
  }

  renderPopoverContent(percentage,text,color,subtext){
    return(
      <div>
        <Row type="flex" justify="start">
          <h5 style={{color: '#9CA3AF'}}>{subtext}</h5>
        </Row>
        <Row type="flex" justify="start" style={{marginLeft: '-5px'}}>
          <h5 style={{color: '#9CA3AF'}}>&nbsp; {text} :<span className="semibold" style={{color: '#ffffff'}}>{percentage}</span></h5>
        </Row>
      </div>
    )
  }

  render () {
    let that = this
    const overviewLoading   = this.state.loading
    console.log(this.state)
    return(
      <div>
      {(that.state.loading || Object.keys(that.state.data).length === 0 )? <div className="spiner">
          <Spin size="large"/>
        </div> :
      <div>
        <Breadcrumb list={[{ text:'Analytics', link:'#' }, { text:'Health check trends', link:'/health-check-trends' }]} classes='mb-1' />
        <Row>
          <Col span={12}>
            <Row type="flex" justify="start">
              <a className="flex flex-row w-full mb-2 items-center" style={{marginTop: 10}}onClick={this.renderHealthChecks.bind(this)}><img className="mt-minus-4 chevronBackLink" style={{marginRight: 5}} src={LeftChevronIcon} /> <span className="GoBackLink" >Go Back</span></a>
            </Row>
          </Col>
        </Row> 
        <Row>
          <Col span={12}>
            <Row type="flex" justify="start">
              <h2 className='font-fig-extrabold text-3xl font-medium leading-tight tracking-tight text-gray-900 sm:text-4xl mb-0'>Health Checks</h2>
            </Row>
          </Col>
          <Col span={12}>
            <Row type="flex" justify="end">
              <img src="https://res.cloudinary.com/ekincare/image/upload/v1562667722/hr_dashboard_overview/group-6.svg" />
            </Row>
          </Col>
        </Row>
        <Card className="health-check-utilization-card" style={{marginBottom: 20,marginTop: 10}}>
          <Row>
            <Col span={12}>
              <h3 className="font-semibold">Overview</h3>
            </Col>
            <Col span={12}>
              <Row type="flex" justify="end">
                <Select 
                  defaultValue="last_30_days" 
                  style={{ width: 150, backgroundColor: '#fff' }} 
                  onChange={this.handleChange.bind(this)}
                  >
                  <Option value="last_30_days">Last 30 Days</Option>
                  <Option value="last_12_months">Last 12 Months</Option>
                  <Option value="last_year">Last Year</Option>
                  <Option value="overall">Overall</Option>
                </Select>
              </Row>
            </Col>  
          </Row>  
          {this.renderChartTrends()}  
        </Card>
      </div>  
      }
      </div>
    )
  }    
}
export default HealthCheckTrends;